// extracted by mini-css-extract-plugin
export default {"container":"appContainer_container__0FO0d","content":"appContainer_content__fWCzt"};